// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2b9uB","footer":"ModalError_footer__1-tuA"};